import {BrandAndMarketListItem, GuidIdAndLabel} from '../../../integrated-client/models';
import { DEFAULT_LIMIT } from '../SearchManager/FormData';
import {DEFAULT_TOTAL_ITEMS} from "../../../utils/Constants";

export interface IFormData {
  showNonEffective: boolean
  offset: number
  limit: number
  group: GuidIdAndLabel | null
  label: string | null
  abtaNumber: string | null
  brandAndMarket: BrandAndMarketListItem | null
  total: number
  currentPage: number
}

export class FormData implements IFormData {
  showNonEffective: boolean
  offset: number
  limit: number
  group: GuidIdAndLabel | null
  label: string | null
  abtaNumber: string | null
  brandAndMarket: BrandAndMarketListItem | null
  total: number
  currentPage: number

  constructor() {
    this.showNonEffective = false;
    this.offset = 0;
    this.limit = DEFAULT_LIMIT;
    this.group = null;
    this.label = null;
    this.abtaNumber = null;
    this.brandAndMarket = null
    this.total = DEFAULT_TOTAL_ITEMS;
    this.currentPage = 1;
  }

}
